import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS
} from "../actions/auth.js";

const initialState = {
  userId: "",
  isLoggingIn: false,
  loginError: "",
  isAuthenticated: false,
  logOutError: false,
  resetPasswordError: "",
  resetPasswordRequest: false,
  resetPasswordSuccess: false
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isLoggingIn: true,
        loginError: false
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        userId: action.userId,
        isLoggingIn: false,
        isAuthenticated: true
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoggingIn: false,
        isAuthenticated: false,
        loginError: action.error
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        userId: "",
        isAuthenticated: false,
        logOutError: false
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        isAuthenticated: true,
        logOutError: true
      };
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordRequest: true
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordRequest: false,
        resetPasswordSuccess: true
      };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordRequest: false,
        resetPasswordSuccess: false,
        resetPasswordError: action.error
      };
    default:
      return state;
  }
};
export default authReducer;
